import { Directive, HostListener } from '@angular/core';

/**
 * Track click to button
 */
@Directive({
    selector: '[appTrackClickButton]'
})

export class TrackClickButtonDirective {

    @HostListener('click', ['$event'])
    onClick($event: Event): void {
        console.log('Button clicked');
    }

}
